import CustomButton from "components/CustomButton/CustomButton";
import { Footer as Container } from "views/components/AttendanceList/styles";

const Footer = ({
	eventData,
	studentsReservation,
	saveAttendance,
	goToEventList,
	closeAndGoToEventList,
}) => {
	return (
		<Container>
			<CustomButton
				variant="terciary"
				text="Cancelar"
				onClick={goToEventList}
			/>
			{eventData.isPresential ? (
				<CustomButton
					disabled={studentsReservation.length === 0}
					text="Guardar asistencia"
					onClick={saveAttendance}
				/>
			) : (
				<CustomButton
					text="Cerrar"
					onClick={closeAndGoToEventList}
				/>
			)}
		</Container>
	);
};

export default Footer;
